import React from "react";
import styles from "./ProjectSelector.module.css";
import { Button } from "../common/Button";

interface Project {
  name: string;
  imageCount: number;
  coverImage: {
    filename: string;
    path: string | null;
  } | null;
  path: string;
}

interface ProjectSelectorProps {
  projects: Project[];
  selectedProject: string | null;
  onSelectProject: (projectName: string | null) => void;
}

export const ProjectSelector: React.FC<ProjectSelectorProps> = ({
  projects,
  selectedProject,
  onSelectProject,
}) => {
  // Filter out root project
  const filteredProjects = projects.filter((p) => p.name !== "root");

  if (filteredProjects.length === 0) {
    return null;
  }

  return (
    <div className={styles.projectSelector}>
      <div className={styles.container}>
        <Button
          variant={selectedProject === null ? "primary" : "ghost"}
          onClick={() => onSelectProject(null)}
        >
          All Work
        </Button>
        {filteredProjects.map((project) => (
          <Button
            key={project.name}
            variant={selectedProject === project.name ? "primary" : "ghost"}
            onClick={() => onSelectProject(project.name)}
          >
            {project.name
              .replace(/-/g, " ")
              .replace(/\b\w/g, (l) => l.toUpperCase())}
            <span className={styles.imageCount}>{project.imageCount}</span>
          </Button>
        ))}
      </div>
    </div>
  );
};
